import { render, staticRenderFns } from "./BibleNotePanel.vue?vue&type=template&id=45c1cc01&scoped=true"
import script from "./BibleNotePanel.vue?vue&type=script&lang=js"
export * from "./BibleNotePanel.vue?vue&type=script&lang=js"
import style0 from "./BibleNotePanel.vue?vue&type=style&index=0&id=45c1cc01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1cc01",
  null
  
)

export default component.exports